import { IMapyBoxItem } from "~/interfaces";
import { icon, node } from "~/util/dom";
import { createUserNoteBtn } from "./btn";
import { getHTMLDescription } from "~/util/mapybox";

const CLAMP_LINES_CLASS = "clamp-lines-3";

interface IUserNote {
	data: IMapyBoxItem;
	foreign?: boolean;
	isPremiumUser?: boolean;
	onEdit?: () => void;
	onRemove?: () => void;
	onNoteOpen?: (container: HTMLDivElement) => void;
}

// poznamka - varianty rozbalena/zabalena, editace a smazani
export function createUserNote({
	data,
	foreign = false,
	isPremiumUser = false,
	onEdit = () => {},
	onRemove = () => {},
	onNoteOpen = () => {},
}: IUserNote) {
	const container = node("div", { className: "user-note show-btn" });
	const text = node("p", { className: `user-note__text ${CLAMP_LINES_CLASS}` });
	const corner = icon("note-right-corner");
	const btnsLine = node("div", { className: "user-note__btnsLine noprintdn" });
	const showBtn = node("button", { className: `user-note__showBtn` });

	btnsLine.append(
		createUserNoteBtn({
			type: "edit",
			isPremiumUser,
			onClick: () => {
				onEdit();
			},
		}),
	);

	if (isPremiumUser) {
		btnsLine.append(createUserNoteBtn({
			type: "remove",
			isPremiumUser,
			onClick: () => {
				onRemove();
			},
		}));
	}

	text.innerHTML = getHTMLDescription(data.description);
	showBtn.append(icon("dropdown"));
	container.append(text, corner, showBtn);

	function showNote() {
		showBtn.remove();
		container.classList.remove("show-btn");
		text.classList.remove(CLAMP_LINES_CLASS);
		container.append(btnsLine);
		onNoteOpen(container);
	}

	showBtn.addEventListener("click", () => {
		showNote();
	});

	if (foreign) {
		container.classList.add("foreign");
	}

	if (!isPremiumUser) {
		container.classList.add("read-only");
	}

	if (!isPremiumUser) {
		// potrebujeme vedet, jestli to zobrazit
		const resizeObserver = new ResizeObserver(entries => {
			const entry = entries[0];

			if (entry.contentRect.width > 0) {
				const scrollHeight = text.scrollHeight;

				if (entry.contentRect.height === scrollHeight) {
					showBtn.remove();
				}

				resizeObserver.disconnect();
			}
		});

		resizeObserver.observe(text);
	}

	return {
		container,
		print: () => {
			// skryjeme
			btnsLine.style.display = "none";
			showNote();
		},
		setNote: (note: string) => {
			text.innerHTML = getHTMLDescription(note);
		},
		destroy: () => {
			container.remove();
		},
	};
}
